import route from '@MAIN/route'

export default {
  data() {
    return {

    }
  },
  methods : {
    route,
  }
}
